import React, { useContext, useEffect, useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import ActionContext from '../../../context/ActionContext';
import {
	trimLongString,
	mapHotkey,
	getCookie,
	setCookie,
} from '../../../utils/helper/Helper';
import './style/index.css';
import onboardingIcon from '../../../assets/sidenav-icon-onboarding.svg';
import { sideMenuList } from './SidemenuList';
import { useLocation, useNavigate } from 'react-router-dom';
import { RavenButton } from '@ravenpay/raven-bank-ui';
import RootState from '../../../redux/types';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu } from '../../../redux/actions/actions';
import { icons } from '../../../assets/icons';

interface MyComponentProps {
	theme: any;
}

const SideMenuComponent: React.FC<MyComponentProps> = ({ theme }) => {
	const [kycStatus, setKycStatus] = useState<boolean>(true);
	const { isMenuOpen } = useSelector((state: RootState) => state.general);

	const { profile } = useSelector((state: RootState) => state.wallet);

	//check if x-pos-key exists and update cache

	const xposKey = profile?.merchantInfo?.bankbox_key;
	const cachdKey = getCookie('x-pos-key');

	useEffect(() => {
		if (xposKey) {
			if (!cachdKey || cachdKey.length < 2) {
				setCookie('x-pos-key', xposKey, 3000);
			}
		}
	}, [xposKey, cachdKey]);

	const ravenWhiteLogo = (
		<svg
			className="img"
			width="92"
			height="28"
			viewBox="0 0 92 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_4059_114526)">
				<path
					d="M4.35349 1.41855C4.95333 2.33037 5.63684 3.16696 6.31916 4.01494C7.82287 5.88875 9.31244 7.78529 10.9293 9.57018C11.4219 10.1138 11.9805 10.5778 12.7324 10.7498C15.7492 11.4337 18.31 9.31945 18.66 6.46315C18.997 3.71519 17.0749 0.803077 14.0275 0.790539C10.8566 0.779142 7.68497 0.768884 4.51259 0.759766C4.11191 0.759766 4.11191 0.977462 4.23683 1.21567C4.27201 1.28523 4.31095 1.35295 4.35349 1.41855ZM25.7425 24.6949C25.5151 24.4886 25.2876 24.2823 25.0578 24.0794C23.7061 22.8713 9.53283 11.8155 3.20096 1.53139C3.16319 1.46591 3.12897 1.39857 3.09843 1.32965C3.08953 1.30502 3.07386 1.28319 3.0531 1.26652C3.03233 1.24985 3.00726 1.23897 2.98059 1.23505C2.86274 1.21795 2.82385 1.31141 2.77671 1.38436C2.58934 1.66816 2.51156 1.99413 2.42318 2.31213C1.87873 4.31357 1.64304 6.35833 1.55229 8.41674C1.49358 9.65868 1.51207 10.9029 1.60768 12.1426C1.74085 13.7691 2.01189 15.3682 2.57284 16.9114C3.10197 18.368 3.86914 19.6856 5.11124 20.6932C5.87843 21.3033 6.78433 21.7287 7.75455 21.9344C7.9596 21.9811 7.99022 21.9447 7.91949 21.7452C7.90773 21.7098 7.8936 21.6757 7.88064 21.6415C7.22227 19.9957 6.5631 18.3502 5.90317 16.7052C5.71226 16.2276 5.51899 15.7511 5.3269 15.2736C5.40555 15.3184 5.46933 15.3841 5.51074 15.4628C6.11883 16.4977 6.72102 17.5372 7.33502 18.5687C7.98548 19.664 8.70789 20.7057 9.70725 21.5389C10.5865 22.2709 11.6194 22.8099 12.7347 23.1186C13.5289 23.3516 14.3475 23.498 15.1753 23.5551C15.2413 23.5551 15.3202 23.5996 15.3674 23.5381C15.4145 23.4765 15.3485 23.4149 15.3143 23.3614C14.9608 22.8155 14.599 22.2683 14.2372 21.7247L11.3724 17.4186C10.5388 16.1694 9.70957 14.9195 8.88469 13.6688L7.90536 12.1871L7.94779 12.1643C7.97726 12.1974 8.00788 12.2281 8.03498 12.2623C8.85991 13.2573 9.62475 14.2877 10.4084 15.3089C11.4042 16.6082 12.4035 17.903 13.4925 19.1329C14.0817 19.7973 14.6839 20.4504 15.332 21.0602C16.2221 21.919 17.201 22.6871 18.2534 23.3523C18.9445 23.7816 19.677 24.145 20.4407 24.4373C21.3047 24.7683 22.2151 24.9723 23.1417 25.0426C23.9902 25.1075 24.8439 25.0564 25.6777 24.8909C25.7355 24.8796 25.8097 24.883 25.8262 24.8112C25.8427 24.7394 25.7791 24.7234 25.7425 24.6949Z"
					fill="white"
				/>
				<path
					d="M67.3347 8.24365H63.7412L62.4626 17.4666H66.4242C67.1783 17.4841 67.9122 17.222 68.488 16.7298C69.0489 16.2625 69.4124 15.5963 69.5035 14.8675C69.578 14.3983 69.5139 13.9174 69.3189 13.485C69.1291 13.0825 68.799 12.7652 68.3911 12.5943C69.192 12.1718 69.6518 11.5258 69.7718 10.6563C69.8734 9.93211 69.7009 9.34872 69.2554 8.90621C68.81 8.46363 68.1701 8.24278 67.3347 8.24365ZM68.3669 14.8675C68.3236 15.1952 68.2174 15.5112 68.0536 15.7973C67.922 16.0363 67.7357 16.2402 67.5106 16.392C67.3266 16.5111 67.1293 16.6066 66.9221 16.6763C66.7531 16.7333 66.5765 16.7636 66.3982 16.7663H63.6893L64.2132 12.9947H66.9221C67.0294 12.9951 67.1368 13.0056 67.2423 13.026C67.3652 13.0521 67.4847 13.0914 67.5995 13.1434C67.7247 13.1974 67.8401 13.2739 67.9388 13.369C68.0432 13.4725 68.1332 13.5896 68.2071 13.7172C68.2924 13.8708 68.3467 14.0402 68.3669 14.2154C68.3911 14.4321 68.3911 14.6508 68.3669 14.8675ZM68.6479 10.6172C68.6092 10.9158 68.5134 11.2041 68.3669 11.4662C68.2492 11.6777 68.0824 11.8568 67.8805 11.9879C67.7178 12.0911 67.5412 12.1714 67.3566 12.2265C67.1973 12.2736 67.0317 12.2978 66.8656 12.2983H64.3165L64.7758 8.93881H67.3347C67.4576 8.9391 67.5799 8.95223 67.6999 8.9779C67.8355 9.00806 67.9659 9.05816 68.087 9.12659C68.218 9.19927 68.3328 9.2982 68.4252 9.41744C68.5261 9.56566 68.5942 9.73425 68.6248 9.9117C68.6733 10.1446 68.6808 10.3842 68.6479 10.6199V10.6172Z"
					fill="white"
				/>
				<path
					d="M75.9883 11.4766C75.8279 11.2717 75.6484 11.0834 75.4517 10.9145C75.263 10.7571 75.0478 10.6356 74.817 10.5558C74.5533 10.4667 74.2769 10.4227 73.9988 10.4254C73.5563 10.4252 73.1184 10.5141 72.7104 10.687C72.3025 10.8598 71.9327 11.1132 71.6228 11.4322C70.9351 12.1034 70.5173 12.9777 70.3702 14.0549C70.226 15.0799 70.3731 15.9259 70.8116 16.5928C71.0032 16.9077 71.2732 17.1661 71.5951 17.3419C71.9171 17.5177 72.2789 17.6047 72.6447 17.5943C73.2141 17.5894 73.768 17.4042 74.2285 17.0649C74.7345 16.7078 75.1436 16.2279 75.4176 15.6694L75.1597 17.4652H76.2589L76.3748 16.6293L76.6149 14.9039L77.2172 10.5546H76.1181L75.9883 11.4766ZM75.7621 13.1172L75.6911 13.6389C75.5705 14.5876 75.1499 15.4714 74.4916 16.1585C74.4437 16.2067 74.3946 16.2537 74.3462 16.298C73.9071 16.704 73.4542 16.9066 72.9862 16.9057C72.8022 16.9102 72.6193 16.873 72.4514 16.797C72.2835 16.721 72.1346 16.6079 72.0152 16.4662C71.7538 16.1619 71.579 15.7913 71.5109 15.3942C71.429 14.9552 71.4226 14.5053 71.4913 14.064C71.5796 13.2885 71.9032 12.5596 72.4173 11.9774C72.9251 11.4087 73.4934 11.1245 74.1229 11.1245C74.3721 11.1237 74.6185 11.1813 74.8424 11.2927C75.1655 11.4598 75.4286 11.7257 75.5936 12.0526C75.7586 12.3794 75.818 12.7506 75.7621 13.1133V13.1172Z"
					fill="white"
				/>
				<path
					d="M82.2184 10.4136C81.8399 10.4121 81.4655 10.4912 81.1193 10.6458C80.7621 10.8061 80.4373 11.0315 80.1609 11.3109C79.862 11.612 79.6116 11.9588 79.4189 12.3385L79.663 10.5558H78.5638L78.0105 14.5413L77.6055 17.4664C77.9101 17.4209 78.1934 17.2832 78.419 17.0712C78.6446 16.8594 78.801 16.5834 78.8685 16.2797C78.8852 16.2002 78.8967 16.1196 78.9019 16.0384L79.2527 13.5266C79.5205 12.8483 79.9376 12.2408 80.4731 11.7504C80.9612 11.3235 81.4406 11.1104 81.9097 11.1113C82.0649 11.1033 82.2196 11.1349 82.3586 11.2033C82.4983 11.2717 82.6188 11.3746 82.7083 11.5026C82.8918 11.7634 82.9448 12.1547 82.8687 12.6763L82.3523 16.3684C82.3332 16.5053 82.3436 16.6448 82.3823 16.7774C82.4215 16.9099 82.4879 17.0325 82.5779 17.1369C82.6673 17.2412 82.7781 17.3248 82.9027 17.3822C83.0273 17.4394 83.1624 17.4691 83.2991 17.4691L83.9753 12.6502C84.0613 12.0216 83.9551 11.4922 83.6568 11.0618C83.358 10.6314 82.8785 10.4153 82.2184 10.4136Z"
					fill="white"
				/>
				<path
					d="M91.1628 10.5559H90.2171L86.2054 13.914L86.8297 9.41211C86.8556 9.30927 86.8706 9.20392 86.8735 9.09781C86.8735 9.07827 86.8735 9.06001 86.8735 9.04047C86.8741 8.74898 86.7922 8.46338 86.6381 8.21703C86.4841 7.97069 86.2637 7.7737 86.0029 7.64893H85.9746L85.5696 10.5637C85.6463 10.5522 85.7213 10.5351 85.7952 10.5129C85.7213 10.5351 85.6463 10.5522 85.5696 10.5637L84.6089 17.4665H85.7075L86.0779 14.8178L86.8955 14.1331L88.241 16.2863C88.4666 16.6476 88.7793 16.9453 89.1491 17.1517C89.5196 17.358 89.9356 17.4663 90.3579 17.4665L87.7898 13.3715L91.1628 10.5559ZM85.9025 10.475C85.9723 10.4476 86.0398 10.4154 86.105 10.3785C86.0398 10.4154 85.9723 10.4476 85.9025 10.475Z"
					fill="white"
				/>
				<path
					d="M28.7916 8.42237H24.4935L23.477 15.6721L23.4551 15.8208C23.4551 15.8665 23.4551 15.9134 23.4551 15.959C23.4542 16.1576 23.4921 16.3544 23.5666 16.5381C23.641 16.7218 23.7506 16.8889 23.8889 17.0297C24.0273 17.1706 24.1918 17.2825 24.373 17.359C24.5542 17.4356 24.7486 17.4752 24.945 17.4758H25.6841L25.7138 17.2593L26.0401 14.9405L26.1691 13.9911H27.1714L27.9918 16.3503L28.0679 16.5681C28.1765 16.8196 28.3508 17.0364 28.5722 17.1952C28.7936 17.354 29.0536 17.4488 29.3243 17.4692H31.2167L30.8452 16.4794L30.1524 14.6366L29.7449 13.5633C30.1571 13.3144 30.5064 12.972 30.7652 12.563C31.024 12.1613 31.193 11.7074 31.2605 11.2328C31.3689 10.4303 31.1874 9.76089 30.7161 9.2244C30.2449 8.68796 29.6034 8.42062 28.7916 8.42237ZM26.3859 12.4769L26.7367 9.92994H27.9918C28.1241 9.92189 28.256 9.95001 28.3738 10.0113C28.4916 10.0725 28.5909 10.1647 28.6613 10.2782C28.807 10.5116 28.8522 10.8429 28.7903 11.2732C28.682 12.0757 28.2975 12.4769 27.6371 12.4769H26.3859Z"
					fill="white"
				/>
				<path
					d="M36.9439 11.3994C36.728 11.1275 36.4524 10.9103 36.1388 10.7652C35.8253 10.62 35.4826 10.551 35.1379 10.5634C34.9489 10.564 34.7604 10.581 34.5742 10.6143C34.3656 10.6527 34.1603 10.7076 33.9602 10.7786C33.7403 10.8563 33.5285 10.9559 33.3281 11.076C33.1101 11.2084 32.908 11.366 32.7258 11.5455C32.3006 11.9547 31.9786 12.4609 31.7867 13.0218C31.6609 13.3654 31.5743 13.7224 31.5287 14.086C31.4519 14.5561 31.4558 15.0361 31.5403 15.5049C31.5999 15.8669 31.7344 16.2123 31.935 16.5182C32.114 16.7707 32.3396 16.9859 32.5993 17.152C32.8371 17.3095 33.0984 17.4271 33.3733 17.5002C33.623 17.5639 33.8795 17.5958 34.1369 17.5954C34.9728 17.5954 35.6789 17.1772 36.255 16.3408L36.0925 17.4754H38.4853L39.4386 10.6939H37.0444L36.9439 11.3994ZM36.6485 13.4939L36.6123 13.7547C36.524 14.4277 36.2674 15.0669 35.8668 15.6118C35.8061 15.6926 35.7455 15.767 35.6849 15.8335C35.414 16.1335 35.1281 16.2834 34.8271 16.2834C34.459 16.2834 34.1958 16.0783 34.0376 15.6679C33.8794 15.2575 33.8458 14.7402 33.937 14.1159C34.029 13.4404 34.2272 12.9 34.5316 12.4949C34.8361 12.0897 35.1801 11.8867 35.5636 11.8859C35.7033 11.8874 35.8409 11.9198 35.9668 11.9808C36.0927 12.0419 36.2038 12.1301 36.2924 12.2393C36.4376 12.4102 36.5446 12.6107 36.606 12.8272C36.6674 13.0438 36.6819 13.2712 36.6485 13.4939Z"
					fill="white"
				/>
				<path
					d="M53.4317 11.1647C53.1994 10.9632 52.9258 10.8163 52.6307 10.7344C52.2301 10.6143 51.8139 10.5567 51.3962 10.5635C50.3927 10.5514 49.4184 10.9045 48.6512 11.5586C47.8773 12.1875 47.3597 13.0827 47.1974 14.073C47.0349 15.045 47.2688 15.8749 47.8992 16.5626C48.5295 17.2503 49.365 17.5946 50.4055 17.5955C51.0597 17.6045 51.7064 17.4547 52.2914 17.1586C52.8305 16.8933 53.2794 16.4721 53.5814 15.9483L52.9428 15.441C52.7615 15.6223 52.5618 15.7835 52.3469 15.9223C51.9781 16.1592 51.5493 16.2828 51.1124 16.2783C49.9945 16.2783 49.4699 15.6962 49.5387 14.5321C49.5409 14.5037 49.5535 14.4771 49.574 14.4576C49.5945 14.4381 49.6214 14.4269 49.6496 14.4264C50.6485 14.4275 51.6356 14.2076 52.5417 13.7821C53.3156 13.4344 53.7666 12.9062 53.8948 12.1976C53.9181 12.0252 53.8921 11.8496 53.82 11.6916C53.7271 11.4913 53.595 11.3121 53.4317 11.1647ZM52.0347 12.5654C51.9178 13.107 51.2831 13.4322 50.1307 13.5409L49.7051 13.5774C49.8185 13.1268 50.03 12.7075 50.3243 12.3502C50.4338 12.2079 50.5733 12.092 50.7325 12.0108C50.8918 11.9296 51.067 11.8851 51.2452 11.8807C51.3552 11.8801 51.4647 11.8928 51.5716 11.9186C51.666 11.9419 51.7564 11.9793 51.8399 12.0294C51.8965 12.0608 51.9448 12.1055 51.9805 12.1598C52.0161 12.2202 52.0393 12.2873 52.0486 12.357C52.0579 12.4267 52.0532 12.4976 52.0347 12.5654Z"
					fill="white"
				/>
				<path
					d="M59.4028 10.5636C59.1357 10.5612 58.8697 10.5994 58.6135 10.677C58.3533 10.7638 58.111 10.8992 57.9004 11.0761C57.6444 11.2897 57.4206 11.5397 57.2358 11.8182L57.4022 10.694H55.0042L54.4521 14.6299L54.1116 17.0465L54.0483 17.4756H55.1474C55.5019 17.4771 55.8454 17.3514 56.1166 17.1206C56.3879 16.8898 56.5692 16.5691 56.6282 16.2157L56.6398 16.1297L56.9894 13.6518C57.2098 13.1742 57.4899 12.7272 57.8225 12.3216C58.081 12.0268 58.3475 11.8781 58.6072 11.8781C59.1074 11.8781 59.2909 12.3681 59.1576 13.3479L58.8518 15.5311L58.7901 15.9745C58.7907 16.35 58.9297 16.7118 59.1801 16.9893C59.4299 17.2668 59.7738 17.4402 60.1431 17.4756H60.9699L60.9947 17.2956L61.3288 14.9011L61.5584 13.2566C61.6756 12.4455 61.5353 11.7934 61.139 11.3004C60.7426 10.8074 60.1639 10.5618 59.4028 10.5636Z"
					fill="white"
				/>
				<path
					d="M45.6641 10.6938L43.6363 14.8671L43.5576 14.4759C43.4812 14.4638 43.404 14.4577 43.3267 14.4576C42.9411 14.4563 42.5701 14.6059 42.2912 14.8749C42.0122 15.144 41.8472 15.5118 41.8305 15.9013C41.8138 16.2907 41.9469 16.6715 42.2017 16.964C42.4566 17.2565 42.8135 17.4378 43.1977 17.4702H43.4647C43.7044 17.4476 43.9351 17.3668 44.1373 17.2346C44.3394 17.1025 44.5069 16.9229 44.6256 16.7112L44.694 16.573L47.6196 10.6938H45.6641Z"
					fill="white"
				/>
				<path
					d="M41.584 10.6938H40.2644L40.3934 11.2912L40.8771 13.5317C41.0771 13.6404 41.2989 13.7016 41.5257 13.7105C41.7526 13.7195 41.9785 13.676 42.1862 13.5834C42.3939 13.4908 42.578 13.3515 42.7244 13.176C42.8709 13.0007 42.9758 12.7938 43.0313 12.5712C43.0867 12.3487 43.0912 12.1162 43.0444 11.8917C42.9976 11.6671 42.9007 11.4562 42.7612 11.2752C42.6216 11.0942 42.443 10.9477 42.2391 10.847C42.035 10.7462 41.811 10.6938 41.584 10.6938Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4059_114526">
					<rect width="91.1628" height="28" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);

	const actionCtx = useContext(ActionContext);

	const location = useLocation();
	const navigate = useNavigate();

	const dispatch = useDispatch();

	function toggleNav() {
		dispatch(toggleMenu(false));
	}

	return (
		<>
			<figure
				onClick={() => dispatch(toggleMenu(!isMenuOpen))}
				className={`tablet-menu-toggle non-desktop non-mobile ${
					isMenuOpen && 'collapsed'
				} `}
			>
				{icons.chevron_down}
			</figure>
			<div className="dashboard-sidemenu-wrap">
				{/* logo box start */}
				<div className="logo-text-box">
					<div className="logo-box">
						<figure className="img-box">
							{theme === 'light' ? ravenWhiteLogo : ravenGreenLogo}
						</figure>
					</div>
					<div className="text side-nav-logo-text">Atlas</div>
				</div>
				{/* logo box end */}

				{/* email name box start */}
				<div className="name-email-drop-box remove-dark-theme-border transparent-fade-white-bg">
					<div className="name-email-box">
						<p className="name">
							{(profile?.fname ?? '--') + ' ' + (profile?.lname ?? '--')}
						</p>
						<p className="email">{trimLongString(profile?.email, 15)}</p>
					</div>
					<div className="icon-box">
						<FaAngleDown className="icon" />
					</div>
				</div>
				{/* email name box end */}
				{/* nav list start */}
				<div className="nav-list-box">
					<div
						//   style={{ marginBottom: !actionCtx.sideMenuDrop.one ? "1.5rem" : "" }}
						className="toggle-nav-box"
					>
						<div
							onClick={() => {
								actionCtx?.setSideMenuDrop('one');
							}}
							className="get-started"
						>
							<p className="title">get Started</p>
							{!actionCtx.sideMenuDrop.one ? (
								<FaAngleDown className="icon" />
							) : (
								<FaAngleUp className="icon" />
							)}
						</div>
						<div
							className={`toggle-hide-show ${
								actionCtx?.sideMenuDrop?.one && 'toggle-show'
							}`}
						>
							{' '}
							<div
								onClick={() => {
									navigate('/dashboard-onboarding');
									toggleNav();
								}}
								className={`nav-link ${
									location.pathname.includes('dashboard-onboarding') &&
									'nav-link-active'
								}`}
							>
								<div className="img-wrap">
									<figure className="img-box">
										<img src={onboardingIcon} alt="" className="img" />
									</figure>
								</div>
								<p className="text">Onboarding</p>
							</div>
						</div>
					</div>
					{/* title start */}
					<div
						style={{
							opacity: !kycStatus ? 0.5 : 1,
							cursor: !kycStatus ? 'no-drop' : '',
							pointerEvents: !kycStatus ? 'none' : 'auto',
						}}
						className="toggle-nav-box"
					>
						<div className="get-started">
							<p className="title">DASHBOARD</p>
						</div>
					</div>
					{/* title end  */}
					{/* list start */}
					<div
						style={{
							opacity: !kycStatus ? 0.5 : 1,
							cursor: !kycStatus ? 'no-drop' : '',
							pointerEvents: !kycStatus ? 'none' : 'auto',
						}}
						className="list-box"
					>
						{sideMenuList?.map((chi, idx) => {
							const { name, icon, link, children, numb } = chi;
							// children box parent start
							if (children && name === 'Wallet') {
								return (
									<div key={idx} className="parent-children-box">
										<div
											onClick={() => {
												actionCtx?.setSideMenuDrop(numb);
											}}
											className={`nav-link nav-link-drop`}
											style={{ cursor: 'pointer' }}
										>
											<div className="img-wrap">
												<figure className="img-box">
													<img src={icon} alt="" className="img" />
												</figure>
											</div>
											<p className="text">{name}</p>
											{!actionCtx?.sideMenuDrop?.two ? (
												<FaAngleDown className="icon" />
											) : (
												<FaAngleUp className="icon" />
											)}
										</div>
										{/* children start ---  */}
										<div
											className={`children-box ${
												actionCtx?.sideMenuDrop?.two && 'children-box-show'
											} ${!isMenuOpen ? 'children-box-menu-clpsed' : ''}`}
										>
											{children?.map((child, i) => {
												const { name, icon, link } = child;
												return (
													<div
														key={i}
														onClick={() => {
															navigate(link);
															toggleNav();
														}}
														className={`nav-link ${
															location?.pathname.includes(link) &&
															'nav-link-active'
														}`}
													>
														<div className="img-wrap">
															<div className="children-spacing"></div>
															{/* <figure className="img-box">
																<img src={icon} alt="" className="img" />
															</figure> */}
														</div>
														<p className="text">{name}</p>
													</div>
												);
											})}
										</div>

										{/* children end ---  */}
									</div>
								);
							}
							if (children && name === 'Payments') {
								return (
									<div key={idx} className="parent-children-box">
										<div
											onClick={() => {
												actionCtx?.setSideMenuDrop(numb);
											}}
											className={`nav-link nav-link-drop`}
											style={{ cursor: 'pointer' }}
										>
											<div className="img-wrap">
												<figure className="img-box">
													<img src={icon} alt="" className="img" />
												</figure>
											</div>
											<p className="text">{name}</p>
											{!actionCtx?.sideMenuDrop?.three ? (
												<FaAngleDown className="icon" />
											) : (
												<FaAngleUp className="icon" />
											)}
										</div>
										{/* children start ---  */}
										<div
											className={`children-box ${
												actionCtx?.sideMenuDrop?.three && 'children-box-show'
											} ${!isMenuOpen ? 'children-box-menu-clpsed' : ''}`}
										>
											{children?.map((child, i) => {
												const { name, icon, link } = child;
												return (
													<div
														key={i}
														onClick={() => {
															navigate(link);
															toggleNav();
														}}
														className={`nav-link ${
															location?.pathname.includes(link) &&
															'nav-link-active'
														}`}
													>
														<div className="img-wrap">
															<div className="children-spacing"></div>
															{/* <figure className="img-box">
																<img src={icon} alt="" className="img" />
															</figure> */}
														</div>
														<p className="text">{name}</p>
													</div>
												);
											})}
										</div>

										{/* children end ---  */}
									</div>
								);
							}

							if (children && name === 'BankBox') {
								const handleLink = (l: string) => {
									const appkey = getCookie('x-pos-key');

									if (!appkey) {
										return '/dashboard-bankbox/overview';
									} else {
										return l;
									}
								};

								return (
									<div key={idx} className="parent-children-box">
										<div
											onClick={() => {
												actionCtx?.setSideMenuDrop(numb);
											}}
											className={`nav-link nav-link-drop`}
											style={{ cursor: 'pointer' }}
										>
											<div className="img-wrap">
												<figure className="img-box bankbox-icon">
													<img src={icon} alt="" className="img" />
												</figure>
											</div>
											<p className="text">{name}</p>
											{!actionCtx?.sideMenuDrop?.four ? (
												<FaAngleDown className="icon" />
											) : (
												<FaAngleUp className="icon" />
											)}
										</div>
										{/* children start ---  */}
										<div
											className={`children-box ${
												actionCtx?.sideMenuDrop?.four && 'children-box-show'
											} ${!isMenuOpen ? 'children-box-menu-clpsed' : ''}`}
										>
											{children?.map((child, i) => {
												const { name, icon, link } = child;
												return (
													<div
														key={i}
														onClick={() => {
															navigate(handleLink(link));
															toggleNav();
														}}
														className={`nav-link ${
															location?.pathname.includes(link) &&
															'nav-link-active'
														}`}
													>
														<div className="img-wrap">
															<div className="children-spacing"></div>
															{/* <figure className="img-box">
																<img src={icon} alt="" className="img" />
															</figure> */}
														</div>
														<p className="text">{name}</p>
													</div>
												);
											})}
										</div>

										{/* children end ---  */}
									</div>
								);
							}
							// children box parent end

							return (
								<div
									key={idx}
									onClick={() => navigate(link)}
									style={{
										cursor: !kycStatus ? 'no-drop' : '',
										pointerEvents: !kycStatus ? 'none' : 'auto',
									}}
									className={`nav-link ${
										location?.pathname.includes(link) && 'nav-link-active'
									}`}
								>
									<div className="img-wrap">
										<figure className="img-box">
											<img src={icon} alt="" className="img" />
										</figure>
									</div>
									<p className="text">{name}</p>
								</div>
							);
						})}
					</div>

					{/* list end */}
				</div>
				{/* nav list end */}
				{/* chat support box start */}
				{/* <div className="chat-support-box">
					<RavenButton
						onClick={() => window.fcWidget.open()}
						size="small"
						color="green-light"
						label="Help and Support"
					/>
				</div> */}
				{/* chat support box end */}
			</div>
		</>
	);
};

export default SideMenuComponent;

export const ravenGreenLogo = (
	<svg
		className="img"
		width="92"
		height="28"
		viewBox="0 0 92 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_4259_198795)">
			<path
				d="M4.35343 1.41855C4.95327 2.33037 5.63678 3.16696 6.3191 4.01494C7.8228 5.88875 9.31238 7.78529 10.9292 9.57018C11.4218 10.1138 11.9804 10.5778 12.7323 10.7498C15.7491 11.4337 18.3099 9.31945 18.6599 6.46315C18.9969 3.71519 17.0749 0.803077 14.0274 0.790539C10.8566 0.779142 7.68491 0.768884 4.51253 0.759766C4.11185 0.759766 4.11185 0.977462 4.23677 1.21567C4.27194 1.28523 4.31089 1.35295 4.35343 1.41855ZM25.7425 24.6949C25.515 24.4886 25.2876 24.2823 25.0578 24.0794C23.7061 22.8713 9.53276 11.8155 3.2009 1.53139C3.16313 1.46591 3.12891 1.39857 3.09837 1.32965C3.08947 1.30502 3.0738 1.28319 3.05303 1.26652C3.03227 1.24985 3.0072 1.23897 2.98052 1.23505C2.86268 1.21795 2.82379 1.31141 2.77665 1.38436C2.58928 1.66816 2.5115 1.99413 2.42312 2.31213C1.87867 4.31357 1.64297 6.35833 1.55223 8.41674C1.49351 9.65868 1.51201 10.9029 1.60762 12.1426C1.74079 13.7691 2.01183 15.3682 2.57278 16.9114C3.10191 18.368 3.86908 19.6856 5.11118 20.6932C5.87837 21.3033 6.78427 21.7287 7.75449 21.9344C7.95954 21.9811 7.99016 21.9447 7.91943 21.7452C7.90767 21.7098 7.89354 21.6757 7.88058 21.6415C7.22221 19.9957 6.56304 18.3502 5.90311 16.7052C5.7122 16.2276 5.51893 15.7511 5.32684 15.2736C5.40549 15.3184 5.46927 15.3841 5.51068 15.4628C6.11876 16.4977 6.72096 17.5372 7.33496 18.5687C7.98542 19.664 8.70783 20.7057 9.70719 21.5389C10.5864 22.2709 11.6193 22.8099 12.7346 23.1186C13.5288 23.3516 14.3474 23.498 15.1752 23.5551C15.2412 23.5551 15.3202 23.5996 15.3673 23.5381C15.4145 23.4765 15.3485 23.4149 15.3143 23.3614C14.9607 22.8155 14.599 22.2683 14.2372 21.7247L11.3723 17.4186C10.5388 16.1694 9.70951 14.9195 8.88462 13.6688L7.9053 12.1871L7.94773 12.1643C7.9772 12.1974 8.00782 12.2281 8.03492 12.2623C8.85985 13.2573 9.62469 14.2877 10.4084 15.3089C11.4042 16.6082 12.4035 17.903 13.4924 19.1329C14.0816 19.7973 14.6838 20.4504 15.332 21.0602C16.222 21.919 17.2009 22.6871 18.2533 23.3523C18.9444 23.7816 19.6769 24.145 20.4406 24.4373C21.3047 24.7683 22.2151 24.9723 23.1416 25.0426C23.9901 25.1075 24.8439 25.0564 25.6777 24.8909C25.7354 24.8796 25.8096 24.883 25.8261 24.8112C25.8426 24.7394 25.779 24.7234 25.7425 24.6949Z"
				fill="#9BE5C9"
			/>
			<path
				d="M67.3347 8.24365H63.7412L62.4626 17.4666H66.4242C67.1783 17.4841 67.9122 17.222 68.488 16.7298C69.0489 16.2625 69.4124 15.5963 69.5035 14.8675C69.578 14.3983 69.5139 13.9174 69.3189 13.485C69.1291 13.0825 68.799 12.7652 68.3911 12.5943C69.192 12.1718 69.6518 11.5258 69.7718 10.6563C69.8734 9.93211 69.7009 9.34872 69.2554 8.90621C68.81 8.46363 68.1701 8.24278 67.3347 8.24365ZM68.3669 14.8675C68.3236 15.1952 68.2174 15.5112 68.0536 15.7973C67.922 16.0363 67.7357 16.2402 67.5106 16.392C67.3266 16.5111 67.1293 16.6066 66.9221 16.6763C66.7531 16.7333 66.5765 16.7636 66.3982 16.7663H63.6893L64.2132 12.9947H66.9221C67.0294 12.9951 67.1368 13.0056 67.2423 13.026C67.3652 13.0521 67.4847 13.0914 67.5995 13.1434C67.7247 13.1974 67.8401 13.2739 67.9388 13.369C68.0432 13.4725 68.1332 13.5896 68.2071 13.7172C68.2924 13.8708 68.3467 14.0402 68.3669 14.2154C68.3911 14.4321 68.3911 14.6508 68.3669 14.8675ZM68.6479 10.6172C68.6092 10.9158 68.5134 11.2041 68.3669 11.4662C68.2492 11.6777 68.0824 11.8568 67.8805 11.9879C67.7178 12.0911 67.5412 12.1714 67.3566 12.2265C67.1973 12.2736 67.0317 12.2978 66.8656 12.2983H64.3165L64.7758 8.93881H67.3347C67.4576 8.9391 67.5799 8.95223 67.6999 8.9779C67.8355 9.00806 67.9659 9.05816 68.087 9.12659C68.218 9.19927 68.3328 9.2982 68.4252 9.41744C68.5261 9.56566 68.5942 9.73425 68.6248 9.9117C68.6733 10.1446 68.6808 10.3842 68.6479 10.6199V10.6172Z"
				fill="#9BE5C9"
			/>
			<path
				d="M75.9883 11.4766C75.8279 11.2717 75.6484 11.0834 75.4517 10.9145C75.263 10.7571 75.0478 10.6356 74.817 10.5558C74.5533 10.4667 74.2769 10.4227 73.9988 10.4254C73.5563 10.4252 73.1184 10.5141 72.7104 10.687C72.3025 10.8598 71.9327 11.1132 71.6228 11.4322C70.9351 12.1034 70.5173 12.9777 70.3702 14.0549C70.226 15.0799 70.3731 15.9259 70.8116 16.5928C71.0032 16.9077 71.2732 17.1661 71.5951 17.3419C71.9171 17.5177 72.2789 17.6047 72.6447 17.5943C73.2141 17.5894 73.768 17.4042 74.2285 17.0649C74.7345 16.7078 75.1436 16.2279 75.4176 15.6694L75.1597 17.4652H76.2589L76.3748 16.6293L76.6149 14.9039L77.2172 10.5546H76.1181L75.9883 11.4766ZM75.7621 13.1172L75.6911 13.6389C75.5705 14.5876 75.1499 15.4714 74.4916 16.1585C74.4437 16.2067 74.3946 16.2537 74.3462 16.298C73.9071 16.704 73.4542 16.9066 72.9862 16.9057C72.8022 16.9102 72.6193 16.873 72.4514 16.797C72.2835 16.721 72.1346 16.6079 72.0152 16.4662C71.7538 16.1619 71.579 15.7913 71.5109 15.3942C71.429 14.9552 71.4226 14.5053 71.4913 14.064C71.5796 13.2885 71.9032 12.5596 72.4173 11.9774C72.9251 11.4087 73.4934 11.1245 74.1229 11.1245C74.3721 11.1237 74.6185 11.1813 74.8424 11.2927C75.1655 11.4598 75.4286 11.7257 75.5936 12.0526C75.7586 12.3794 75.818 12.7506 75.7621 13.1133V13.1172Z"
				fill="#9BE5C9"
			/>
			<path
				d="M82.2185 10.4136C81.84 10.4121 81.4655 10.4912 81.1193 10.6458C80.7622 10.8061 80.4373 11.0315 80.161 11.3109C79.8621 11.612 79.6117 11.9588 79.419 12.3385L79.663 10.5558H78.5639L78.0106 14.5413L77.6055 17.4664C77.9102 17.4209 78.1935 17.2832 78.4191 17.0712C78.6447 16.8594 78.801 16.5834 78.8685 16.2797C78.8853 16.2002 78.8968 16.1196 78.902 16.0384L79.2528 13.5266C79.5205 12.8483 79.9377 12.2408 80.4731 11.7504C80.9612 11.3235 81.4407 11.1104 81.9098 11.1113C82.065 11.1033 82.2196 11.1349 82.3587 11.2033C82.4983 11.2717 82.6189 11.3746 82.7083 11.5026C82.8918 11.7634 82.9449 12.1547 82.8687 12.6763L82.3523 16.3684C82.3333 16.5053 82.3437 16.6448 82.3823 16.7774C82.4216 16.9099 82.4879 17.0325 82.5779 17.1369C82.6674 17.2412 82.7782 17.3248 82.9028 17.3822C83.0274 17.4394 83.1624 17.4691 83.2992 17.4691L83.9754 12.6502C84.0614 12.0216 83.9552 11.4922 83.6569 11.0618C83.358 10.6314 82.8785 10.4153 82.2185 10.4136Z"
				fill="#9BE5C9"
			/>
			<path
				d="M91.1628 10.5559H90.2171L86.2054 13.914L86.8297 9.41211C86.8556 9.30927 86.8706 9.20392 86.8735 9.09781C86.8735 9.07827 86.8735 9.06001 86.8735 9.04047C86.8741 8.74898 86.7922 8.46338 86.6381 8.21703C86.4841 7.97069 86.2637 7.7737 86.0029 7.64893H85.9746L85.5696 10.5637C85.6463 10.5522 85.7213 10.5351 85.7952 10.5129C85.7213 10.5351 85.6463 10.5522 85.5696 10.5637L84.6089 17.4665H85.7075L86.0779 14.8178L86.8955 14.1331L88.241 16.2863C88.4666 16.6476 88.7793 16.9453 89.1491 17.1517C89.5196 17.358 89.9356 17.4663 90.3579 17.4665L87.7898 13.3715L91.1628 10.5559ZM85.9025 10.475C85.9723 10.4476 86.0398 10.4154 86.105 10.3785C86.0398 10.4154 85.9723 10.4476 85.9025 10.475Z"
				fill="#9BE5C9"
			/>
			<path
				d="M28.7915 8.42237H24.4934L23.477 15.6721L23.455 15.8208C23.455 15.8665 23.455 15.9134 23.455 15.959C23.4542 16.1576 23.4921 16.3544 23.5665 16.5381C23.6409 16.7218 23.7505 16.8889 23.8889 17.0297C24.0273 17.1706 24.1918 17.2825 24.3729 17.359C24.5542 17.4356 24.7485 17.4752 24.9449 17.4758H25.684L25.7137 17.2593L26.0401 14.9405L26.1691 13.9911H27.1714L27.9918 16.3503L28.0679 16.5681C28.1764 16.8196 28.3508 17.0364 28.5721 17.1952C28.7935 17.354 29.0536 17.4488 29.3242 17.4692H31.2166L30.8451 16.4794L30.1524 14.6366L29.7448 13.5633C30.157 13.3144 30.5064 12.972 30.7651 12.563C31.024 12.1613 31.193 11.7074 31.2605 11.2328C31.3688 10.4303 31.1874 9.76089 30.7161 9.2244C30.2449 8.68796 29.6033 8.42062 28.7915 8.42237ZM26.3858 12.4769L26.7367 9.92994H27.9918C28.124 9.92189 28.2559 9.95001 28.3737 10.0113C28.4915 10.0725 28.5908 10.1647 28.6612 10.2782C28.807 10.5116 28.8522 10.8429 28.7902 11.2732C28.6819 12.0757 28.2974 12.4769 27.637 12.4769H26.3858Z"
				fill="#9BE5C9"
			/>
			<path
				d="M36.9438 11.3994C36.728 11.1275 36.4523 10.9103 36.1388 10.7652C35.8252 10.62 35.4825 10.551 35.1379 10.5634C34.9489 10.564 34.7603 10.581 34.5742 10.6143C34.3655 10.6527 34.1602 10.7076 33.9601 10.7786C33.7402 10.8563 33.5284 10.9559 33.3281 11.076C33.11 11.2084 32.9079 11.366 32.7257 11.5455C32.3005 11.9547 31.9785 12.4609 31.7866 13.0218C31.6608 13.3654 31.5743 13.7224 31.5286 14.086C31.4518 14.5561 31.4558 15.0361 31.5402 15.5049C31.5998 15.8669 31.7343 16.2123 31.9349 16.5182C32.114 16.7707 32.3395 16.9859 32.5993 17.152C32.837 17.3095 33.0984 17.4271 33.3732 17.5002C33.6229 17.5639 33.8794 17.5958 34.1369 17.5954C34.9727 17.5954 35.6788 17.1772 36.255 16.3408L36.0924 17.4754H38.4853L39.4386 10.6939H37.0444L36.9438 11.3994ZM36.6484 13.4939L36.6123 13.7547C36.524 14.4277 36.2673 15.0669 35.8667 15.6118C35.8061 15.6926 35.7454 15.767 35.6848 15.8335C35.4139 16.1335 35.128 16.2834 34.827 16.2834C34.4589 16.2834 34.1958 16.0783 34.0376 15.6679C33.8793 15.2575 33.8458 14.7402 33.9369 14.1159C34.029 13.4404 34.2272 12.9 34.5316 12.4949C34.8361 12.0897 35.18 11.8867 35.5636 11.8859C35.7032 11.8874 35.8408 11.9198 35.9668 11.9808C36.0927 12.0419 36.2038 12.1301 36.2924 12.2393C36.4375 12.4102 36.5445 12.6107 36.6059 12.8272C36.6674 13.0438 36.6819 13.2712 36.6484 13.4939Z"
				fill="#9BE5C9"
			/>
			<path
				d="M53.4318 11.1647C53.1995 10.9632 52.9259 10.8163 52.6307 10.7344C52.2302 10.6143 51.8139 10.5567 51.3962 10.5635C50.3928 10.5514 49.4185 10.9045 48.6513 11.5586C47.8774 12.1875 47.3598 13.0827 47.1975 14.073C47.035 15.045 47.2689 15.8749 47.8992 16.5626C48.5296 17.2503 49.365 17.5946 50.4056 17.5955C51.0597 17.6045 51.7065 17.4547 52.2915 17.1586C52.8306 16.8933 53.2795 16.4721 53.5814 15.9483L52.9429 15.441C52.7616 15.6223 52.5619 15.7835 52.3469 15.9223C51.9782 16.1592 51.5494 16.2828 51.1125 16.2783C49.9945 16.2783 49.4699 15.6962 49.5387 14.5321C49.541 14.5037 49.5535 14.4771 49.5741 14.4576C49.5946 14.4381 49.6215 14.4269 49.6497 14.4264C50.6486 14.4275 51.6357 14.2076 52.5417 13.7821C53.3157 13.4344 53.7667 12.9062 53.8948 12.1976C53.9182 12.0252 53.8922 11.8496 53.8201 11.6916C53.7271 11.4913 53.5951 11.3121 53.4318 11.1647ZM52.0348 12.5654C51.9178 13.107 51.2832 13.4322 50.1308 13.5409L49.7051 13.5774C49.8185 13.1268 50.0301 12.7075 50.3243 12.3502C50.4339 12.2079 50.5734 12.092 50.7326 12.0108C50.8919 11.9296 51.067 11.8851 51.2453 11.8807C51.3552 11.8801 51.4648 11.8928 51.5717 11.9186C51.666 11.9419 51.7564 11.9793 51.84 12.0294C51.8966 12.0608 51.9448 12.1055 51.9806 12.1598C52.0162 12.2202 52.0393 12.2873 52.0487 12.357C52.058 12.4267 52.0532 12.4976 52.0348 12.5654Z"
				fill="#9BE5C9"
			/>
			<path
				d="M59.403 10.5636C59.1358 10.5612 58.8698 10.5994 58.6136 10.677C58.3534 10.7638 58.1111 10.8992 57.9005 11.0761C57.6445 11.2897 57.4207 11.5397 57.2359 11.8182L57.4023 10.694H55.0043L54.4522 14.6299L54.1117 17.0465L54.0485 17.4756H55.1475C55.502 17.4771 55.8455 17.3514 56.1168 17.1206C56.388 16.8898 56.5693 16.5691 56.6284 16.2157L56.64 16.1297L56.9896 13.6518C57.21 13.1742 57.49 12.7272 57.8226 12.3216C58.0811 12.0268 58.3477 11.8781 58.6073 11.8781C59.1075 11.8781 59.291 12.3681 59.1577 13.3479L58.8519 15.5311L58.7902 15.9745C58.7908 16.35 58.9298 16.7118 59.1802 16.9893C59.4301 17.2668 59.7739 17.4402 60.1432 17.4756H60.97L60.9948 17.2956L61.3289 14.9011L61.5585 13.2566C61.6757 12.4455 61.5355 11.7934 61.1391 11.3004C60.7427 10.8074 60.164 10.5618 59.403 10.5636Z"
				fill="#9BE5C9"
			/>
			<path
				d="M45.664 10.6938L43.6362 14.8671L43.5575 14.4759C43.4811 14.4638 43.4039 14.4577 43.3266 14.4576C42.9411 14.4563 42.57 14.6059 42.2911 14.8749C42.0122 15.144 41.8471 15.5118 41.8304 15.9013C41.8138 16.2907 41.9468 16.6715 42.2017 16.964C42.4565 17.2565 42.8134 17.4378 43.1976 17.4702H43.4646C43.7043 17.4476 43.935 17.3668 44.1372 17.2346C44.3393 17.1025 44.5069 16.9229 44.6256 16.7112L44.6939 16.573L47.6196 10.6938H45.664Z"
				fill="#9BE5C9"
			/>
			<path
				d="M41.584 10.6938H40.2643L40.3933 11.2912L40.877 13.5317C41.077 13.6404 41.2988 13.7016 41.5257 13.7105C41.7525 13.7195 41.9784 13.676 42.1861 13.5834C42.3939 13.4908 42.5779 13.3515 42.7244 13.176C42.8708 13.0007 42.9757 12.7938 43.0312 12.5712C43.0866 12.3487 43.0911 12.1162 43.0443 11.8917C42.9975 11.6671 42.9006 11.4562 42.7611 11.2752C42.6215 11.0942 42.443 10.9477 42.239 10.847C42.035 10.7462 41.8109 10.6938 41.584 10.6938Z"
				fill="#9BE5C9"
			/>
		</g>
		<defs>
			<clipPath id="clip0_4259_198795">
				<rect width="91.1628" height="28" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
